<!--  PENDING APPROVALS  -->
<div class="card mb-2">
    <div class="card-body position-relative">
        <div class="row align-items-center mb-2">
            <div class="col text-center">
                <span class="fw-bold">Pending Class Recording Requests</span>
                @if(!supportRequests?.error){
                    @if(appService.isFetchingMyRequests) {
                        <i class="fas fa-circle-notch fa-spin ms-3"></i>
                    }
                    @else if(!!pendingRequests?.length) {
                        ({{pendingRequests.length}})
                    }
                }
                
            </div>
            @if(!!pendingRequests?.length) {
                <div class="col-auto">
                    <button class="btn btn-primary btn-sm"
                            type="button"
                            (click)="isRecordingsCollapsed = !isRecordingsCollapsed"
                            [attr.aria-expanded]="!isRecordingsCollapsed"
                            aria-controls="collapseExample">
                        {{ isRecordingsCollapsed ? 'Expand' : 'Collapse' }}
                    </button>
                </div>
            }
        </div>
        @if (!!supportRequests?.error){
            <p>Oops! Looks like we can't get information from Solar Winds! There may be a problem with their services.</p>
            <p>If the problem persists, please contact the IT Service Desk at <a href="mailto:itservicedesk@kenan-flagler.unc.edu">itservicedesk@kenan-flagler.unc.edu</a>.</p>
        }
        @else if(appService.isFetchingMyRequests) {
            <!--  Do nothing if we're still waiting  for pendingRequests to return -->
        }
        @else if(!pendingRequests?.length){
            No pending requests found
        }
        @else if(!!pendingRequests?.length) {
            <div [ngbCollapse]="isRecordingsCollapsed" id="collapseExample" class="mt-2">
                
                <div class="container">
                    @for (recording of pendingRequests; track recording) {
                        <div class="row align-items-center mb-2">
                            <div class="col">
                                <span>{{recording.name}}</span>
                            </div>
                            <div class="col-auto">
                                <button class="btn btn-outline-primary btn-sm" (click)="showRecordingRequest(recording)">Details</button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</div>

<!--  SECTION RECORDING FORM  -->
<div class="alert alert-warning">
    <ul>
        <li>IT Academic Technologies requires at least 2 business days notice prior to the requested recording date</li>
        <li>Use the same start & end date for a single class</li>
        <li>Touch panel has to be logged in to to activate cameras</li>
    </ul>
</div>

@if(classrooms$ | async){} <!--  Trigger this early so the data is ready when we need it  -->

@if(isSearchingSections){
    <div class="d-flex justify-content-center"><i class="fas fa-circle-notch fa-spin ms-3"></i></div>
}
@else {
    @if ( sections$ | async; as sections ) {
        @if(!!sections.length){
            <dropdown [(obj)]="request" prop="section"
                      label="Section" [labelCols]="allLabelCols"
                      [listOfOptions$]="sections$" [invalidValueMode]="invalidValueMode.AllowEnabled"
                      [optionsToShow]="1" [maxSelectionCount]="1"
                      (value$)="onSectionSelected($event)"
                      placeholder="Select one">
            </dropdown>
        }
        @else{
            <div class="alert alert-danger text-center">No sections found</div>
        }
    }
    
    @if ( !!request.section ) {
        <date-time [(obj)]="request" prop="startDate"
                   label="Start Date" [labelCols]="allLabelCols"
                   min="{{now}}" max="{{(now.getFullYear() + 1)}}-12-31T23:59:00"
                   placeholder="Select a date"></date-time>
        
        <date-time [(obj)]="request" prop="endDate"
                   label="End Date" [labelCols]="allLabelCols"
                   min="{{now}}" max="{{(now.getFullYear() + 1)}}-12-31T23:59:00"
                   placeholder="Select a date"></date-time>
        
        <text-input [(obj)]="request" prop="meetingPattern"
                    label="Meeting Pattern" [labelCols]="allLabelCols"
                    [updateValue]="request.meetingPattern"
                    placeholder="Type here"></text-input>
        
        <date-time [(obj)]="request" prop="classStartTime"
                   label="Class Start Time" [labelCols]="allLabelCols"
                   [allowDate]="false" [allowTime]="true"
                   [updateValue]="request.classStartTime"
                   placeholder="Select a time"></date-time>
        
        <date-time [(obj)]="request" prop="classEndTime"
                   label="Class End Time" [labelCols]="allLabelCols"
                   [allowDate]="false" [allowTime]="true"
                   [updateValue]="request.classEndTime"
                   placeholder="Select a time"></date-time>
        
        <text-input [(obj)]="request" prop="location"
                    label="Location" [labelCols]="allLabelCols"
                    [typeaheadList$]="classroomList$ | typeaheadBinder : this"
                    [focusOpenTypeahead]="true"
                    [isDisabled]="!(classrooms$ | async)"
                    [requireTypeaheadSelection]="true"
                    [updateValue]="request.location"
                    placeholder="Type here">
        </text-input>
        
        <text-input [(obj)]="request" prop="additionalInstructions"
                    label="Addl Instructions" [labelCols]="allLabelCols"
                    [mode]="inputMode.TextArea" [maxLength]="500"
                    placeholder="Type here"></text-input>
        
        <p>By submitting this form, you acknowledge and agree to adhere to all relevant university policies governing recording and privacy.</p>
        
        <div>
            <strong>Disclaimer:</strong><br />
            <div class="alert alert-warning">
                <ul>
                    <li>Devices and screens will be recorded <strong>even if they are blanked</strong>.</li>
                    <li>Even if the touch panel is not activated, the <strong>classroom audio will still be recorded</strong> if a recording is scheduled in Panopto.</li>
                </ul>
            </div>
            For additional information on Panopto at Kenan-Flagler, please see the Lecture Capture and Recording tab on
            the <a href="https://tech.kenan-flagler.unc.edu/it/it-services/academic-technologies-services/" target="_blank">Academic Technologies IT Services Page</a>
        </div>
        <br>
        
        @if (submit$ | async) {}
        
        <button type="button" class="btn btn-primary" [disabled]="request.hasErrors || isSubmitting" (click)="submit()">
            Submit @if (isSubmitting) {<i class="fa-solid fa-circle-notch fa-spin ms-1"></i>}
        </button>
    }
}


